import { MutableRefObject } from 'react';

export const isRefDefined = <RefType>(
  ref: MutableRefObject<RefType | null | undefined>
): ref is MutableRefObject<RefType> => ref.current != null;
